import topCrossPlatformMobileAppDevelopmentCompanies from "../images/top-cross-platform-mobile-app-development-companies.svg";
import topWooCommerceDevelopers from "../images/top-woocommerce-developers.svg";
import accreditedAgency from "../images/accredited-agency.png";
import topClutchDevelopment from "../images/badge-clutch.svg";
import topBigCommerceDevelopment from "../images/top_clutch.co_bigcommerce_company_ahmedabad_2024.png";
import topClutchIot from "../images/top_clutch.co_iot_company_ahmedabad_2024.png";
import eCommerceDesignRush from "../images/eCommerce Development  - Singular - Year.png";
import bigCommerceDesignRush from "../images/BigCommerce Website Design  - Singular - Year.png";
import offShoreDesignRush from "../images/Offshore Software Development   - Singular - Year.png";
import wordpressDesignRush from "../images/WordPress Development  - Singular.png";
import clutchBadge from "../images/clutch-100-list-badge.png";


const awardsAndAchievementsData = [
  {
    id: 13,
    img: topClutchDevelopment,
    pathUrl: "https://clutch.co/profile/equest-solutions",
    height: "180px",
    width: "auto",
  },
  {
    id: 16,
    img: clutchBadge,
    pathUrl: "https://clutch.co/profile/equest-solutions",
    height: "180px",
    width: "auto",
  },
  {
    id: 14,
    img: topBigCommerceDevelopment,
    pathUrl: "https://clutch.co/profile/equest-solutions?utm_source=clutch_top_company_badge&utm_medium=image_embed#highlights",
    height: "180px",
    width: "auto",
  },
  {
    id: 15,
    img: topClutchIot,
    pathUrl: "https://clutch.co/profile/equest-solutions?utm_source=clutch_top_company_badge&utm_medium=image_embed#highlights",
    height: "180px",
    width: "auto",
  },
  {
    id: 1,
    img: "https://www.topdevelopers.co/assets/badges/app-2022/Software-Development/Badge-Top-Software-Development-Companies-2022.png",
    pathUrl: "https://www.topdevelopers.co/profile/equest-solutions",
    height: "180px",
    width: "auto",
  },
  {
    id: 2,
    img: "https://www.topdevelopers.co/assets/badges/app-2022/Mobile-App/Global/Badge-Top-Mobile-App-Development-Companies-2022.png",
    pathUrl: "https://www.topdevelopers.co/profile/equest-solutions",
    height: "180px",
    width: "auto",
  },
  {
    id: 3,
    img: topWooCommerceDevelopers,
    pathUrl: "https://www.designrush.com/agency/ecommerce/woocommerce",
    height: "190px",
    width: "auto",
  },
  {
    id: 4,
    img: accreditedAgency,
    pathUrl: "https://www.designrush.com/agency/profile/equest-solutions",
    height: "auto",
    width: "auto",
  },
  {
    id: 5,
    img: topCrossPlatformMobileAppDevelopmentCompanies,
    pathUrl: "https://www.designrush.com/agency/profile/equest-solutions",
    height: "170px",
    width: "auto",
  },
  {
    id: 6,
    img: "https://www.topdevelopers.co/assets/badges/app-2022/Ecommerce/Badge-Top-Ecommerce-Development-Companies-2022.png",
    pathUrl: "https://www.topdevelopers.co/profile/equest-solutions",
    height: "180px",
    width: "auto",
  },
  {
    id: 7,
    img: "https://www.appfutura.com/img/badges/badge-top-shopify-company.png",
    pathUrl: "https://www.appfutura.com/companies/equest_solutions",
    height: "180px",
    width: "auto",
  },
  {
    id: 8,
    img: "https://www.itfirms.co/wp-content/uploads/2022/04/top-full-stack-development-companies-2022.png",
    pathUrl: "https://www.itfirms.co/top-mobile-app-development-companies/",
    height: "180px",
    width: "auto",
  },
  {
    id: 9,
    img: "https://www.itfirms.co/wp-content/uploads/2022/04/top-ecommerce-development-companies-2022.png",
    pathUrl: "https://www.itfirms.co/top-mobile-app-development-companies/",
    height: "180px",
    width: "auto",
  },
  {
    id: 10,
    img: "https://assets.goodfirms.co/badges/color-badge/ecommerce-development-companies.svg",
    pathUrl: "https://www.goodfirms.co/company/equest-solutions",
    height: "180px",
    width: "auto",
  },
  {
    id: 11,
    img: "https://assets.goodfirms.co/badges/normal-badge/top-software-development-companies.svg",
    pathUrl: "https://www.goodfirms.co/company/equest-solutions",
    height: "180px",
    width: "auto",
  },
  {
    id: 12,
    img: "https://topwebdevelopmentcompanies.com/badges/top-web-development-companies.png",
    pathUrl:
      "https://topwebdevelopmentcompanies.com/in/top-10/web-development/india",
    height: "200px",
    width: "auto",
  },
  {
    id: 16,
    img: eCommerceDesignRush,
    pathUrl: "https://www.designrush.com/agency/ecommerce/shopify",
    height: "180px",
    width: "auto",
  },
  {
    id: 17,
    img: bigCommerceDesignRush,
    pathUrl: "https://www.designrush.com/agency/website-design-development/trends/custom-websites-user-experience",
    height: "180px",
    width: "auto",
  },
  {
    id: 18,
    img: offShoreDesignRush,
    pathUrl: "https://www.designrush.com/agency/software-development/offshore-software-developers",
    height: "180px",
    width: "auto",
  },
  {
    id: 19,
    img: wordpressDesignRush,
    pathUrl: "https://www.designrush.com/agency/web-development-companies/wordpress",
    height: "180px",
    width: "auto",
  },
];
export default awardsAndAchievementsData;
